/* eslint-disable */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
	Badge, IconButton, Tooltip
} from '@mui/material';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import OpenInFull from '@mui/icons-material/OpenInFull';
import CloseFullscreen from '@mui/icons-material/CloseFullscreen';
import { Bell } from 'lucide-react';
import {
	modalActions, navigationActions, productActions
} from '../../Actions';
import { classes, useWindowDimensions } from '../../Helpers/utils';
import HamburgerToCross from '../Icons/HamburgerToCross/HamburgerToCross';
import { AccountMenu } from '../Menus/AccountMenu';
import styles from './Appbar.module.scss';
import packageJson from '../../../package.json';
import { useAuth } from '../Auth/Login/auth';
import ChangePasswordModal from '../Modals/ChangePasswordModal/ChangePasswordModal';
import { notificationServices } from '../../Services/Notification';
import { authServices } from '../../Services';
import guide from '../../Images/guide.png';
import drawerActions from '@/Actions/drawer.actions';
import { useSmartNotificationPolling } from '@/Helpers/notificationHook';
import NotificationDrawer from '../Drawers/NotificaitonDrawer/NotificationDrawer';
import inventory from '../../Images/inventory.png';
import price from '../../Images/updatePriceIcon.png';
import Timer from '../timer';
import EmailVerificationModal from '../Modals/emailVerificationModal';
import RmPriceUpdateModal from '../Modals/RmPriceUpdateModal/RmPriceUpdate';
import { notShowNotificationtoCustomer, showPackagingNotificationtoCustomer } from '@/config/config';
import MultiPoModal from '../Modals/MultiPoModal/multiPoModal';

const Appbar = (props) => {
	const { width } = useWindowDimensions();
	const {
		showSidebar,
		toggleSidebar,
		toggleChangePasswordModal,
		showInternalData,
		toggleEmailVerificationModal,
	} = props;
	const { appConfig = {}, userConfig = {}, userStores = [] } = useAuth();
	const { consoleHelpUrl = '', daysLimit = 5 } = appConfig?.configs ?? {};
	const { userDetails = {} } = userConfig || {};
	const { id: userId, level } = userDetails || {};
	const { userRolesDict = {} } = userConfig || {};

	const location = useLocation();
	const isDashboard = location?.pathname === '/console2/dashboard';
	const isA2bCustomer = appConfig?.customerId === 68 || appConfig?.customerId === 5 || appConfig.customerId === 70 || appConfig.customerId === 73 || appConfig.customerId === 74;
	const isInternal = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL');
	const isBakingoCustomer = appConfig?.customerId === 52;
	// eslint-disable-next-line no-unused-vars
	const [isFullscreen, setIsFullscreen] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(productActions?.fetchProducts());
	}, []);

	const { unreadCount, refetch, isLoading } = useSmartNotificationPolling(userId, isA2bCustomer);

	const notificationOrders = useSelector((state) => state?.wastage?.notification?.list?.orders || []);
	const storesNotPunched = useSelector((state) => state?.wastage?.notification?.storesNotPunched || []);
	// Count distinct stores (by toStoreId), so a store ordering in multiple shifts isn't double counted.
	const punchedStoreIds = new Set();
	notificationOrders.forEach((n) => {
		(n?.orders || []).forEach((order) => {
			if (order?.toStoreId != null) punchedStoreIds.add(order.toStoreId);
		});
	});
	const notPunchedStoreIds = new Set(storesNotPunched.map((s) => s?.storeId).filter((id) => id != null));
	const punchedStoresCount = punchedStoreIds.size;
	// Only RETAIL stores punch orders, so the denominator should exclude BASE/WAREHOUSE stores.
	const retailUserStores = Array.isArray(userStores) ? userStores.filter((s) => s?.storeType === 'RETAIL') : [];
	const totalStoresCount = Array.isArray(userStores) ? retailUserStores.length : new Set([...punchedStoreIds, ...notPunchedStoreIds]).size;

	// Distinct stores that have punched orders today but no packaging order created yet.
	const packagingMissing = useSelector((state) => state?.wastage?.notification?.packagingMissing || []);
	const packagingStoresCount = new Set(packagingMissing.map((s) => s?.storeId).filter((id) => id != null)).size;

	const handleChangePassword = async (state) => {
		const req = {
			data: {
				...state,
				userId: userConfig?.userDetails?.id,
			},
		};
		try {
			const response = await authServices?.changePassword(req);
			if (response?.statusCode === 200) {
				notificationServices?.generateNotification({
					type: 'success',
					message: response?.message,
				});
				toggleChangePasswordModal(false, {});
			} else {
				notificationServices?.generateNotification({
					type: 'error',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleFullscreen = () => {
		if (!document.fullscreenElement) {
			setIsFullscreen(true);
			document.documentElement.requestFullscreen();
		} else {
			setIsFullscreen(false);
			document.exitFullscreen();
		}
	};

	const handleNotificationDrawer = (data) => {
		// data?.focus lets a badge tell the drawer which section to surface on top.
		dispatch(drawerActions.toggleNotificationDrawer(true, data?.focus ? { focus: data.focus } : {}));
	};

	const sendBackupCodeToMail = async () => {
		const req = {
			data: {
				userId: userConfig?.userDetails?.id,
			},
		};
		try {
			const response = await authServices?.backupCode(req);
			if (response?.statusCode === 200) {
				notificationServices?.generateNotification({
					type: 'success',
					message: `Backup codes sent to your email ${userConfig?.userDetails?.email}`,
				});
			} else {
				notificationServices?.generateNotification({
					type: 'error',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices?.generateNotification({
				type: 'error',
				message: error?.message,
			});
		}
	};

	const handleOpenModal = () => {
		dispatch(modalActions.toggleMultiplePoModal(true));
	};

	return (
		<>
			{isDashboard && (
				<div
					onClick={handleFullscreen}
					className={styles['hide-show-btn']}
				>
					{!isFullscreen ? (
						<OpenInFull fontSize='1.25rem' />
					) : (
						<CloseFullscreen fontSize='1.25rem' />
					)}
					{/* {visible ? 'Hide Navbar' : 'Hide Navbar'} */}
				</div>
			)}
			<div
				className={classes(
					styles.root,
					showInternalData ? styles.internal : ''
				)}
			>
				<ChangePasswordModal handleConfirm={handleChangePassword} />
				<NotificationDrawer handleRefresh={refetch} loading={isLoading} />
				<EmailVerificationModal />
				<RmPriceUpdateModal />
				<MultiPoModal />
				<div className={styles.left}>
					{width < 1200 && (
						<IconButton
							onClick={toggleSidebar}
							className={styles.hamburger}
							size='large'
						>
							<HamburgerToCross open={showSidebar} />
						</IconButton>
					)}
					{(appConfig?.logob64 || appConfig?.logo) && (
						<img
							className={styles['client-logo']}
							src={appConfig?.logob64 ?? appConfig?.logo}
							alt={appConfig?.companyName}
						/>
					)}
					<p className={styles.heading}>
						Console
						<span>
							v
							{packageJson?.version}
						</span>
					</p>
				</div>
				<div
					className={styles.right}
					style={{
						paddingRight: '7rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '8px',
					}}
				>
					{['68', 68, '5', 5].includes(appConfig?.customerId) && level > 1 && (
						<div
							className='flex items-center bg-yellow-100 border border-yellow-300 rounded-md px-2 py-1.5 shadow-sm cursor-pointer transition-colors duration-200 max-w-[140px]'
							onClick={() => dispatch(modalActions.toggleRmPriceModal(true))}
						>
							<div className='flex items-center gap-1.5 w-full'>
								<img src={price} alt='price' className='w-5 h-5 flex-shrink-0' />
								<div className='flex flex-col min-w-0 flex-1'>
									<span className='font-semibold text-[10px] text-black leading-tight truncate'>
										Update RM Prices
									</span>
									<span className='text-[9px] text-orange-600 font-medium leading-tight'>
										<Timer mode='days' daysLeft={daysLimit} />
									</span>
								</div>
							</div>
						</div>
					)}
					{isA2bCustomer && (
						unreadCount?.leftOver > 0 ? (
							<div
								className='flex items-center bg-yellow-100 border border-yellow-300 rounded-md px-2 py-1.5 shadow-sm cursor-pointer transition-colors duration-200 max-w-[140px]'
								onClick={handleNotificationDrawer}
							>
								<div className='flex items-center gap-1.5 w-full'>
									<img src={inventory} alt='inventory' className='w-5 h-5 flex-shrink-0' />
									<div className='flex flex-col min-w-0 flex-1'>
										<span className='font-semibold text-[10px] text-black leading-tight truncate'>
											{unreadCount?.leftOver}
											{' '}
											Left Overs
										</span>
										<span className='text-[9px] text-orange-600 font-medium leading-tight'>
											<Timer />
										</span>
									</div>
								</div>
							</div>
						) : (
							<Badge badgeContent={0} color='default' max={99}>
								<img src={inventory} alt='inventory' className='w-5 h-5 cursor-pointer' onClick={handleNotificationDrawer} />
							</Badge>
						))}
					{!notShowNotificationtoCustomer.includes(appConfig?.customerId) && (
						unreadCount?.orders > 0 ? (
							<div
								className='flex items-center bg-yellow-100 border-2 border-yellow-400 rounded-full px-2 py-1 shadow-sm cursor-pointer gap-2'
								onClick={handleNotificationDrawer}
							>
								<span className='flex items-center justify-center w-5 h-5 rounded-full bg-transparent relative'>
									<Bell size={20} className='text-black' />
									<span className='absolute top-0 right-0 w-2.5 h-2.5 bg-amber-500 border-2 border-yellow-100 rounded-full' />
								</span>
								<span className='font-semibold text-[12px] text-black'>
									{punchedStoresCount}
									{totalStoresCount > 0 ? `/${totalStoresCount}` : ''}
									{' '}
									Stores Punched Orders
								</span>
							</div>
						) : (
							<div
								className='flex items-center bg-yellow-100 border-2 border-yellow-400 rounded-full px-3 py-1.5 shadow-sm cursor-pointer gap-2'
								onClick={appConfig?.customerId !== 67 ? handleOpenModal : null}
							>
								<Bell size={20} className='text-gray-500 flex-shrink-0' />
								<div className='flex flex-col'>
									<span className='text-[10px] font-semibold text-gray-700'>0 orders available.</span>
									<span className='text-[10px] font-semibold text-gray-700'>Production plan pending.</span>
								</div>
							</div>
						)
					)}
					{showPackagingNotificationtoCustomer.includes(appConfig?.customerId) && packagingStoresCount > 0 && (
						<div
							className='flex items-center bg-yellow-100 border-2 border-yellow-400 rounded-full px-2 py-1 shadow-sm cursor-pointer gap-2'
							onClick={() => handleNotificationDrawer({ focus: 'packagingMissing' })}
						>
							<span className='flex items-center justify-center w-5 h-5 rounded-full bg-transparent relative'>
								<Bell size={20} className='text-black' />
								<span className='absolute top-0 right-0 w-2.5 h-2.5 bg-amber-500 border-2 border-yellow-100 rounded-full' />
							</span>
							<span className='font-semibold text-[12px] text-black'>
								{packagingStoresCount}
								{punchedStoresCount > 0 ? `/${punchedStoresCount}` : ''}
								{' '}
								Stores Packaging Pending
							</span>
						</div>
					)}
					<AccountMenu
						handleChangePassword={() => {
							toggleChangePasswordModal(true, {});
						}}
						handleEmailVerification={() => {
							toggleEmailVerificationModal(true, {});
						}}
						handleBackupCode={() => {
							sendBackupCodeToMail();
						}}
						isA2bCustomer={isA2bCustomer}
						isBakingoCustomer={isBakingoCustomer}
						isInternal={isInternal}
					/>
					{consoleHelpUrl && (
						<Tooltip title='Helper documentation for smooth uy console operation'>
							<div className='w-[40px] h-[40px] cursor-pointer relative top-[4px]'>
								<a href={consoleHelpUrl} target='_blank' rel='noopener noreferrer'>
									<img className='w-full h-full' src={guide} alt='consoleDocumentation' />
								</a>
							</div>
						</Tooltip>
					)}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const { showSidebar, showInternalData } = state?.navigation;
	return {
		showSidebar,
		showInternalData,
	};
};

const mapDispatchToProps = {
	toggleSidebar: navigationActions.toggleSidebar,
	toggleChangePasswordModal: modalActions.toggleChangePasswordModal,
	toggleEmailVerificationModal: modalActions.toggleEmailVerificationModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Appbar);
